<template>
    <MainPage pageTitle="ช่วยเหลือ" bgClass="bg-a-gray-fafafa" menuBar>
        <div class="flex flex-col my-12 items-center justify-center">
            <div class="w-full">
                <div class="m-auto mx-4 text-center ">
                    <div class="text-16 font-medium mb-2 text-a-black-555555">
                        สอบถามเกี่ยวกับสิทธิพิเศษ
                    </div>
                    <div class="text-12 font-light text-a-black-484848">
                        กรุณาติดต่อศูนย์บริการลูกค้า บริษัท บัซซี่ บีส์ จำกัด
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <OrangeButton
                        customClass="my-6 w-80 py-3 rounded-full"
                        @click="callPhone()"
                    >
                        {{ `โทร 02-645-1203` }}
                    </OrangeButton>
                </div>
                <div class="m-auto mx-4 text-center text-12">
                    <div class="font-medium my-2 text-a-black-555555">
                        โดยแจ้งรหัสช่วยเหลือ 6
                        หลักที่ปรากฏด้านล่างแก่เจ้าหน้าที่
                    </div>
                    <div class="font-light text-a-black-484848">
                        ทุกวัน เวลา 10.00 - 17.30 น. (ยกเว้นวันหยุดนักขัตฤกษ์)
                    </div>
                </div>
                <div
                    class="flex items-center justify-center h-44 mt-14 bg-white"
                >
                    <div class="">
                        <div class="m-auto mx-4 text-center ">
                            <div
                                class="text-16 font-medium text-a-black-555555"
                            >
                                รหัสช่วยเหลือของคุณคือ
                            </div>
                            <div
                                class="text-46 font-medium tracking-4.5px my-2 text-a-orange-fe5000"
                            >
                                {{ codeHelp }}
                            </div>
                            <div
                                class="text-12 font-medium leading-5 text-a-black-484848"
                            >
                                รหัสช่วยเหลือคือหมายเลขอ้างอิง
                                <br />
                                เพื่อยืนยันบัญชีของคุณ
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </MainPage>
</template>
<script>
import MainPage from "@/components/Layout/Page/MainPage.vue";
import OrangeButton from "@/components/Button/OrangeButton.vue";
import HelpService from "../service/HelpService.js"

export default {
    name: "Help",
    components: { MainPage, OrangeButton },
    data() {
        return {
            codeHelp: ""
        };
    },
    created: function() {
        this.getHelpCode();
    },
    methods: {
        callPhone: function() {
            window.open("tel:026451203");
        },
        getHelpCode: function() {
            return new Promise((resolve) => {
                HelpService.apiGetHelpCode().subscribe({
                    next: (data) => {
                        // console.log(data.code)
                        this.codeHelp = data.code;
                        resolve();
                        this.$emit('onLoaded');
                    },
                    error: (err) => {
                        this.errorApi(err);

                        resolve();
                    },
                });
            });
        },
    }
};
</script>

